export default __webpack_public_path__ + "static/media/5.7fdd5a01.png";